const Config = {
  VITE_HC_API_URL: process.env.HC_API_URL,
  VITE_HC_API_VERSION: process.env.HC_API_VERSION,
  VITE_APP_ENVIRONMENT: process.env.APP_ENVIRONMENT,
  VITE_GOOGLE_CLIENT_ID: process.env.GOOGLE_OAUTH_CLIENT_ID,
  VITE_SENTRY_AUTH_TOKEN: process.env.SENTRY_AUTH_TOKEN,
  VITE_SENTRY_DSN: process.env.SENTRY_DSN,
  VITE_TINYMCE_EDITOR_API_KEY: process.env.TINYMCE_EDITOR_API_KEY,
  VITE_TEST_MODE_TOKEN: process.env.TEST_MODE_TOKEN,
  LAST_COMMIT_DATA: process.env.LAST_COMMIT,
  LAST_COMMIT_HASH: process.env.COMMIT_HASH,
  DEV_WHITELIST: process.env.DEV_EMAILS_WHITELIST,
};

export default Config;
